import { createSlice } from "@reduxjs/toolkit";
import { UpdateAppData } from "../types/UpdateAppType";
import { uploadAttachmentAction } from "../action/UploadAttachmentAction";

const initialState: UpdateAppData = {
  data: {},
  loading: false,
  error: null,
};

const uploadAttachmentSlice = createSlice({
  name: "uploadAttachmentSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(uploadAttachmentAction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(uploadAttachmentAction.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(uploadAttachmentAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const uploadAttachmentReducer = uploadAttachmentSlice.reducer;
